<template>
  <div id="mobile">
    <div class="box">
      <img @click="display" class="caidan" src='@/assets/img_app/header1.png' alt="">
        <img class="logo" src="@/assets/img_app/logo.png" alt="">
        <div class="box_title">招生信息网</div>
    </div>

    <div class="menu-box" v-if="isShow" @touchmove.prevent @mousewheel.prevent>
      <div class="window">
        <div class="list-box" v-for="(item) in this.$nav1" :key="item.id" >
          <div class="title" @click="jump(item)">
            <div class="name">{{item.name}}</div>
            <img class="more" src="" alt="">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      isShow: false
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    display () {
      this.isShow = !this.isShow
    },
    jump (item) {
      if (item.flag) {
        window.open(item.url)
      } else {
        this.$router.push(item.url)
        this.isShow = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#mobile{
  .box {
    width: 100%;
    height: 13.8667vw;
    padding-right:  10.8vw;
    padding-left:  4.2667vw;
    border-bottom: 0.1333vw solid rgba(0,0,0,.1);
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .caidan{
    width: 4.8vw;
    height: 4vw;
  }

    .logo{
      width: 50.4vw;
      height: 8.5333vw;
    }
    .box_title {
      border-left: 1px solid #0061A9;
      padding-left: 2.6667vw;
      font-size: 4.5333vw;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #0061A9;
    }

  .menu-box{
    height: 100vh;
    position: absolute;
    background: rgba(0,0,0, .4);
    z-index: 999;
    top: 13.3333vw;
    left: 0;
    overflow-y: hidden;
    .window{
      width: 100vw;
      height: 70vh;
      overflow: auto;
      background: #fff;
      padding: 0 4.8vw;
    .list-box{
      width: 100%;
      border-bottom: 1px solid #F5F4F4;
      padding:4.5vw 0;
      .title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name{
          font-size: 4.2667vw;
          font-weight: 500;
          color: #333333;
        }
        .more{
          width: .16rem;
          height: .28rem;
        }
      }
      .list{
        font-size: .26rem;
        font-weight: 400;
        color: #333333;
        line-height: 39px;
        }
      }
    }
  }
}
</style>
